<span class="time-display" [ngClass]="{'long-time': timerValue >= 60*60*1000}" data-cy="recorder-time">{{timerValue | formatTime: 'timer'}}</span>
